export const API_URL = 'https://gis.sevenn.be/api/';
export const BASE_LAYERS_API_URL = API_URL;
// Development requests use Vite's proxy so upstream errors remain readable.
export const GEOSERVER_URL = import.meta.env.DEV
  ? '/geoserver/ows'
  : 'https://geo.sevenn.be/geolinq/ows';
export const POI_ICON_SIZE = {
  width: 20.8,
  height: 27.3
};
//export const ADDRESS_LAYER = 'geolinq:nl_full_address'; // or your backend base URL
export const countryConfig = {
  NL: {
    layer: 'geolinq:nl_full_address',
    columns: {
      postcode: 'u104723postcode6_BAG', //'u107260postcode',
      houseNumber: 'u107260huisnummer',
      street: 'u107260straatnaam'
    }
  },
  BE: {
    layer: 'geolinq:be_full_address',
    columns: {
      postcode: 'postcode',
      houseNumber: 'housenumber',
      street: 'streetname'
    }
  }
};
